import React from 'react';

import Actions from '../item-actions';
import Action from './action';
import Checkmark from '../images/ui/checkmark';
import FieldItem from '../form/field-item';

const RequestResetCode = () => {
  return (
    <form className='item-details item-panel' name='login' method='post' action='/login/password'>
      <fieldset className='item-header-and-meta'>
        <div className='item-header'>
          <h3>Request a password reset code.</h3>
        </div>

        <div className='item-meta'>
          <Actions size='large'>
            <Action
              actionRequired={true}
              isDisabled={false}
              title='Request a code'
              type='save'
            >
              <Checkmark />
            </Action>
          </Actions>
        </div>
      </fieldset>

      <fieldset className='item-description'>
        <FieldItem name='login-username' label='Email address'>
          <input
            type='text'
            name='login[username]'
            id='login-username'
            autoFocus
          />
        </FieldItem>
      </fieldset>
    </form>
  );
};

export default RequestResetCode;
